module.exports = __webpack_public_path__ + "img/ai-chat-close-icon.1d063de4.svg";